<style scoped>
.container {
  max-width: 75rem;
}
p {
  text-indent: 2rem;
  font-size: 1.3rem;
  font-weight: normal;
}
h2 {
  margin-bottom: 3rem;
}
h3 {
  text-align: center;
}
h4 {
  font-size: 1.5rem;
}
ol {
  margin-left: 2rem;
}
li {
  margin-top: 2rem;
  font-size: 1.5rem;
  font-weight: bold;
}
button {
  font-size: 2rem;
  font-weight: bold;
}
blockquote {
  font-style: italic;
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.5rem;
}
address {
  margin-bottom: 2rem;
  font-size: 1.5rem;
}
cite {
  font-size: 1.3rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
  display: block;
}
.subheader {
  font-size: 2rem;
  color: black;
}
.itemtitle {
  font-size: 1.5rem;
  color: black;
}
.itemsubtitle {
  font-size: 1.3rem;
}
</style>

<template>
  <v-container>
    <v-card
      class="mx-auto"
      max-width="50rem"
      elevation="0"
    >
      <v-list three-line="true">
        <v-subheader class="subheader">Annotations by Chapter</v-subheader>
        <v-list-item-group v-model="item" color="primary">
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            :inactive="item.inactive"
            :to="item.link"
          >
            <v-list-item-avatar v-if="avatar">
              <v-img :src="item.avatar"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-html="item.title" class="itemtitle"></v-list-item-title>
              <v-list-item-subtitle v-if="twoLine || threeLine" v-html="item.subtitle" class="itemsubtitle"></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      items: [
        {
          title: 'Chapter 1',
          subtitle: "Goth Off!",
          link: '/marianne-annotations/01'
        },
        {
          title: 'Chapter 2',
          subtitle: "Beauty &amp; the Jackass",
          link: '/marianne-annotations/02'
        },
        {
          title: 'Chapter 3',
          subtitle: "Fattractive Untruths",
          link: '/marianne-annotations/03'
        },
        {
          title: 'Chapter 4',
          subtitle: "Discomfort Zone",
          link: '/marianne-annotations/04'
        },
        {
          title: 'Chapter 5',
          subtitle: "Drawn and Quartered",
          link: '/marianne-annotations/05'
        },
        {
          title: 'Chapter 6',
          subtitle: "Vengeance is Mine (no annotations yet)",
          link: '/marianne-annotations/06',
          // inactive: true,
        },
        {
          title: 'Chapter 7',
          subtitle: "Decease and Desist",
          link: '/marianne-annotations/07'
        },
        {
          title: 'Chapter 8',
          subtitle: "Poetry is Averse to Me",
          link: '/marianne-annotations/08'
        },
        {
          title: 'Chapter 9',
          subtitle: "Prophylactically Challenged",
          link: '/marianne-annotations/09'
        },
        {
          title: 'Chapter 10',
          subtitle: "Telepathetic",
          link: '/marianne-annotations/10'
        },
        {
          title: 'Chapter 11',
          subtitle: "Pwned in perpetuum",
          link: '/marianne-annotations/11'
        },
        {
          title: 'Chapter 12',
          subtitle: "Pestiferous Date",
          link: '/marianne-annotations/12'
        },
        {
          title: 'Chapter 13',
          subtitle: "Slime-Hearted",
          link: '/marianne-annotations/13'
        },
        {
          title: 'Chapter 14',
          subtitle: "Primeval Train Wreck",
          link: '/marianne-annotations/14'
        },
        {
          title: 'Chapter 15',
          subtitle: "First Loser",
          link: '/marianne-annotations/15'
        },
        {
          title: 'Chapter 16',
          subtitle: "U-N-L-O-Q-U-A-C-I-O-U-S",
          link: '/marianne-annotations/16'
        },
        {
          title: 'Chapter 17',
          subtitle: "Martyr",
          link: '/marianne-annotations/17'
        },
        {
          title: 'Chapter 18',
          subtitle: "Bloody Mary",
          link: '/marianne-annotations/18'
        },
        {
          title: 'Chapter 19',
          subtitle: "All Haloes' Eve",
          link: '/marianne-annotations/19'
        },
        {
          title: 'Chapter 20',
          subtitle: "One of the Classic Blunders",
          link: '/marianne-annotations/20'
        },
        {
          title: 'Chapter 21',
          subtitle: "Blue Screen of Death",
          link: '/marianne-annotations/21'
        },
        {
          title: 'Chapter 22',
          subtitle: "Propaganda Machine",
          link: '/marianne-annotations/22'
        },
        {
          title: 'Chapter 23',
          subtitle: "Weeping and Gnashing of Teeth",
          link: '/marianne-annotations/23'
        },
        {
          title: 'Chapter 24',
          subtitle: "My-Newt Mishap",
          link: '/marianne-annotations/24'
        },
        {
          title: 'Chapter 25',
          subtitle: "Class B Pyrotechnic Explosives? Check.",
          link: '/marianne-annotations/25'
        },
        {
          title: 'Chapter 26',
          subtitle: "Nothing But Reruns",
          link: '/marianne-annotations/26'
        },
        {
          title: 'Chapter 27',
          subtitle: "The Tiniest Violin",
          link: '/marianne-annotations/27'
        },
        {
          title: 'Chapter 28',
          subtitle: "Cringe Cauldron",
          link: '/marianne-annotations/28'
        },
        {
          title: 'Chapter 29',
          subtitle: "If You Don’t Believe Me, You’re in De-Nile",
          link: '/marianne-annotations/29'
        },
        {
          title: 'Chapter 30',
          subtitle: "Fattening the Calf",
          link: '/marianne-annotations/30'
        },
        {
          title: 'Chapter 31',
          subtitle: "The Disinterment of Marianne York",
          link: '/marianne-annotations/31'
        },
        {
          title: 'Epilogue',
          subtitle: "",
          link: '/marianne-annotations/epilogue'
        },
      ],
      disabled: false,
      dense: false,
      twoLine: false,
      threeLine: true,
      shaped: false,
      flat: false,
      subheader: false,
      inactive: false,
      subGroup: false,
      nav: false,
      avatar: false,
      rounded: false,
    }),
  }
</script>